import { masks } from './components/phone-input/phone-masks';
var ɵ0 = masks;
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };
export { ɵ0 };
